<template>
  <div class="delete-status-account" />
</template>

<script>
export default {
  name: 'StatusAccountDelete',
  mounted() {
    this.$buefy.dialog.confirm({
      title: 'Borrar estado de cuenta',
      message: '¿Estas seguro de borrar el estado de cuenta?',
      confirmText: 'Borrar',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          await this.$store.dispatch(
            'customers/deleteStatusAccount',
            { customerId: this.$route.params.customer, companyId: this.$route.params.company },
          );

          this.$success({ message: 'El estado de cuenta se eliminó correctamente' });

          this.$router.push({ name: 'Customers', query: { page: 1, size: 20 } });
        } catch (error) {
          this.$danger({ message: 'Ocurrió un error al momento de borrar el estado de cuenta' });
        }
      },
      onCancel: () => {
        this.$router.push({ name: 'Customers', query: { page: 1, size: 20 } });
      },
    });
  },
};
</script>

<style scoped>
</style>
